import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dcb759b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "BroadcastBanner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "BroadcastBanner__kkcoin" }, null, -1))
const _hoisted_3 = ["innerHTML"]

import { broadcast } from '@/api/broadcast';
import { computed, onMounted, reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = ref(false);

const msgList = reactive<{ arr: Array<string> }>({ arr: [] });

const msgWrap = ref();
const broadcastMsg = ref();
const transitionMsg = ref();
const message = ref();

const broadcastMsgText = computed(() => {
  return msgList.arr.reduce((prev, cur) => {
    return (prev += `${cur}&nbsp;&nbsp;&nbsp;&nbsp;`);
  }, '&nbsp;&nbsp;&nbsp;&nbsp;');
});

onMounted(async () => {
  try {
    let { code, data, message: msg } = await broadcast();
    if (code === 200) {
      msgList.arr = data;
      show.value = true;
      setTimeout(() => {
        let msgWrapWidth = msgWrap.value.clientWidth;
        let broadcastMsgDom = broadcastMsg.value;
        broadcastMsgDom.style.minWidth = `${msgWrapWidth}px`;
        transitionMsg.value.style.minWidth = `${msgWrapWidth}px`;
        let msgDom = message.value;
        let startCarousel = () => {
          msgDom.style.webkitTransition = `${Math.floor(
            msgDom.clientWidth / 40
          )}s linear all`;
          msgDom.style.webkitTransform = `translate3d(-${broadcastMsgDom.clientWidth}px, 0, 0)`;
        };

        startCarousel();

        msgDom.addEventListener('webkitTransitionEnd', () => {
          msgDom.style.webkitTransition = '0s linear all';
          msgDom.style.webkitTransform = 'translate3d(0, 0, 0)';
          setTimeout(() => {
            startCarousel();
          }, 0);
        });
      }, 150);
    } else {
      console.error('broadcast', msg);
      show.value = false;
    }
  } catch (error) {
    console.error(error);
    show.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "BroadcastBanner__wrap",
          ref_key: "msgWrap",
          ref: msgWrap
        }, [
          _createElementVNode("div", {
            class: "BroadcastBanner__message",
            ref_key: "message",
            ref: message
          }, [
            _createElementVNode("div", {
              class: "BroadcastBanner__msg",
              ref_key: "broadcastMsg",
              ref: broadcastMsg,
              innerHTML: _unref(broadcastMsgText)
            }, null, 8, _hoisted_3),
            _createElementVNode("div", {
              class: "BroadcastBanner__transition",
              ref_key: "transitionMsg",
              ref: transitionMsg
            }, null, 512)
          ], 512)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})